import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { AuditLogList } from '../interfaces/auditLog.interface';
import { mapAuditLogFilterOptions, mapAuditLogList } from '../mappers/auditLog.mapper';

const list = (payload: AuditLogList) => {
  const { searchText, startDate, endDate, entity, module, event, user, systemOnly, ...others } = payload;
  const paging = buildPagingResponse(others);

  return http.post(`${API_ENDPOINTS.listAuditLogs}?${queryString.stringify(paging)}`, {
    search: searchText || undefined,
    date_from: startDate || undefined,
    date_to: endDate || undefined,
    entity: entity || undefined,
    module: module || undefined,
    event: event || undefined,
    causer_id: user || undefined,
    system_only: systemOnly || undefined,
  }).then((res: any) => mapAuditLogList(res));
};

const filters = () => http.get(API_ENDPOINTS.auditLogFilters).then((res: any) => mapAuditLogFilterOptions(res));

const AuditLogService = { list, filters };

export default AuditLogService;
